module.exports = __webpack_public_path__ + "static/media/msc.eae9d094.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logos/msc.png
// module id = 364
// module chunks = 0